import {FetchStatus} from '../common/FetchStatus.enum';
import {AppConfig, Maybe, UserFragment} from '../graphql/generated/types';

export interface UserState {
  user?: Maybe<UserFragment> & Maybe<Under14AgeAuth>;
  fetchStatus: FetchStatusType;
  error: {
    message?: string;
  };
  appConfig?: Maybe<AppConfig>;
}

/**
 * 14세 미만 유저가 보호자 인증 받았을 경우 사용되는 값이다.
 * 현재는 14세 미만 일 경우 age_auth API를 호출하고 있는데,
 * TODO: 보호자 인증되어있을 경우 로그인 API에서 보호자인증 완료에 대한 값을 추가로 내려주면 age_auth API 호출을 줄일 수 있다.
 */
export interface Under14AgeAuth {
  isParentCertificated?: Maybe<boolean>;
}

type FetchStatusType = {
  [index in UserFetchStatusKey]: FetchStatus;
};

export enum UserFetchStatusKey {
  Signup = 'signup',
  UpdateProfileImage = 'updateProfileImage',
  GetUserData = 'getUserData',
}
